/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Shortage_Warning_DescInputs */

const vi_packaging_shortage_warning_desc = /** @type {(inputs: Packaging_Shortage_Warning_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Một số vật tư không đủ tồn cho đơn này. Có thể xác nhận và hệ thống sẽ ghi log thiếu hàng.`)
};

/**

* @param {Packaging_Shortage_Warning_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_shortage_warning_desc = /** @type {((inputs?: Packaging_Shortage_Warning_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Shortage_Warning_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_shortage_warning_desc(inputs)
});